import React from "react"
import { Link } from "gatsby"
import Styles from "./css/footerlinks.module.scss"
import FooterlinksSingle from "@tightrope/footerlinks/footerlinks_single"
import siteData from "branding/site-metadata.json"


class UpdatedPrivacy extends React.Component {
  constructor(props){
    super(props);
    if(props.data){
      this.state = {
        data: props.data
      }
    }
  }

  render() {
    return (
      <section>

        <div className ={Styles.footerlinksContainer}>
        <img src ={siteData.logo} className={Styles.siteLogo}/>
          <h1>Privacy Policy</h1>
          <h4 id="title" style={{margintop: 10}}>Last Updated June, 2022</h4>
          <h2>Contents</h2>
          <ol>
            <a href="#scope"><li>Scope</li></a>
            <a href="#data"><li>What data do we use?</li></a>
            <a href="#why"><li>Why do we use this data?</li></a>
            <a href="#cookies"><li>Do we use web browser cookies, or pixels?</li></a>
            <a href="#ever-contact"><li>Will we ever contact you (and how to opt-out)?</li></a>
            <a href="#share-data"><li>Will we share this data?</li></a>
            <a href="#children"><li>U.S. Children’s Online Privacy Protection Act (“COPPA”)</li></a>
            <a href="#cali-consumer"><li>California Consumer Privacy Act (“CCPA”)</li></a>
            <a href="#8.1">8.1 Consumers With Disabilities; Non-Discrimination</a><br />
            <a href="#8.2">8.2 Designated Methods For Submitting CCPA Requests</a><br />
            <a href="#8.3">8.3 Personal Information</a><br />
            <a href="#8.4">8.4 Necessity To Maintain Your Personal Information</a><br />
            <a href="#8.5">8.5 Opt-out / Opt-in For Sale Of Personal Information</a>
            <a href="#eu-data"><li>E.U. General Data Protection Regulation (“GDPR”)</li></a>
            <a href="#9.1">9.1 GDPR Owner</a><br />
            <a href="#9.2">9.2 Personal Data</a><br />
            <a href="#9.3">9.3 Disclosure</a><br />
            <a href="#9.4">9.4 Data Retention</a><br />
            <a href="#9.5">9.5 Contact GDPR Owner</a>
            <a href="#cws"><li>Privacy Practices Disclosure For Chrome Web Store</li></a>
            <a href="#policy-updates"><li>Policy Updates</li></a>
            <a href="#contact-us"><li>Contact Us</li></a>
          </ol>
          <p>This website (“site”), "service", application ("app"), and web browser extension ("extension") are owned and operated by Tightrope Interactive, Inc. (“we”, “our”, “us”), a Delaware (U.S.) corporation.</p>
          <h3 id="scope">1. Scope</h3>
          <p>This Privacy Policy (“Privacy Policy”) pertains to your use (“user”, “you”, “your”) of our site, service, app, extension, and web push notifications ("Notifications"). They may be collectively referred to as "products" except when specified otherwise.</p>
          <h3 id="data">2. What data do we use?</h3>
          <p>The data we may use includes:</p>
          <ul>
            <li>IP Address – Your public “Internet Protocol” address sent to us by your web browser.</li>
            <li>GUID – A unique “Generic User Identification” created when you visit our site, use our service, install our app, add our extension, or subscribe to Notifications.</li>
            <li>UA – The “User Agent” and version of your web browser; e.g. Chrome 84, Firefox 79, Safari 13, etc.</li>
            <li>OS – The “Operating System” and version used by your hardware; e.g. Windows 10, macOS 10.15, etc.</li>
            <li>Anonymous service diagnostic data ("diagnostic data"), including but not limited to network connection conditions.</li>
          </ul>
          <h3 id="why">3. Why do we use this data?</h3>
          <p>We may use this data to enable us to make our products work for you.</p>
          <ul>
            <li>We use your public IP address to determine geography, and prevent fraudulent use of our products.</li>
            <li>We use a GUID to ensure the proper functionality of our products.</li>
            <li>We use your UA and OS information to optimize our products for your web browser and operating system.</li>
            <li>We use anonymous diagnostic data to maintain quality of service.</li>
          </ul>
          <h3 id="cookies">4. Do we use web browser cookies, or pixels?</h3>
          <p>Cookies are removable text files stored in your web browser. We may ask your web browser to store one or more cookies when you use our products in order to make them work for you.
            Pixels or “web beacons” are similar in function to cookies. We may ask your web browser to load pixels for our products to better understand how you use them so we can improve them, and for other business purposes.</p>
          <h3 id="ever-contact">5. Will we ever contact you (and how to opt-out)?</h3>
          <ul>
            <li>If you contact us, we may reply using the contact information you provide at that time.</li>
            <li>You can <a href="/uninstall/" target="_blank">disable or remove our app or extension at any time</a>.</li>
            <li>If you opt-in via your web browser to Notifications, we may send them to you via the mechanisms built-in to your User Agent and/or OS.</li>
            <ul id="disabled-notf" style={{display: 'none'}}><li>You\'ve disabled this site\'s Notifications. If you are still seeing notifications, please try our manual <a href="/unsubscribe/" target="_blank">unsubscribe instructions.</a></li></ul>
            <ul id="never-subscribed"><li>This web browser profile is not subscribed to this site\'s Notifications.</li>
              <li>If you are still seeing notifications from the web address of this site, please try our manual <a href="/unsubscribe/" target="_blank">unsubscribe instructions.</a></li></ul>
            <ul id="not-disabled" style={{display: 'none'}}><li className="fancy">If you opted-in via your web browser to this site\'s Notifications, you can unsubscribe by using <span onClick = {() => window.checkSubscription()} style={{cursor: 'pointer', color: 'blue'}}>this link</span>.</li> You can also disable this site’s Notifications via your <a href="/unsubscribe/" target="_blank"> web browser settings </a>(a.k.a. options or preferences).</ul>
          </ul>
          <h3 id="share-data"><span id="section_six">6. Will we share this data?</span></h3>
          <p>Your data may pass through third-party service providers that we use to make our products work for you. These third-parties may include:</p>
          <ul>
            <li>Amazon Web Services <a href="//aws.amazon.com/compliance/data-privacy-faq/" target="_blank">(Data Privacy FAQ)</a></li>
            <li>Cloudflare <a href="//www.cloudflare.com/privacypolicy/" target="_blank">(Privacy Policy)</a></li>
            <li>Google <a href="//policies.google.com/privacy" target="_blank">(Privacy Policy)</a>; Google Analytics <a href="//tools.google.com/dlpage/gaoptout" target="_blank">Opt-out Browser</a> Add-on</li>
            <li>IBM Cloud <a href="//www.ibm.com/privacy/" target="_blank">(Privacy Statement)</a></li>
            <li>Verizon Media <a href="//www.verizonmedia.com/policies/index.html" target="_blank">(Privacy Centers)</a></li>
          </ul>
          <h3 id="children">  7. U.S. Children’s Online Privacy Protection Act (“COPPA”)</h3>
          <p>We do not knowingly collect or sell information from children under the age of 13 pursuant to the Children’s Online Privacy Protection Act of 1998, 15 U.S.C. 6501-6505. We encourage parents and legal guardians to be familiar with the Internet activity of their children. For more information, visit the United States Federal Trade Commission <a href="https://consumer.ftc.gov/articles/protecting-your-childs-privacy-online" target="_blank">website</a> about protecting kids online.</p>
          <h3 id="cali-consumer">8. California Consumer Privacy Act (“CCPA”)</h3>
          <p>This Section 8 applies to you if you are a natural person who is a California resident, as defined in Section 17014 of Title 18 of the California Code of Regulations. This section describes our good faith effort to meet our obligations if CCPA applies to you.</p>
          <h2 id="8.1">8.1 Consumers With Disabilities; Non-Discrimination</h2>
          <p>Consumers with disabilities can submit a CCPA request as described below in Section 8.2. We will make a reasonable effort to furnish Section 8 in an alternative format that you can consume.
            You have a right not to receive discriminatory treatment by us for the exercise of the privacy rights conferred by the CCPA.</p>
          <h2 id="8.2">8.2 Designated Methods For Submitting CCPA Requests</h2>
          <p>You can contact us to submit a CCPA request via <a id="ccpalink" href={"//privacy.tightropeinteractive.com/?domain="+siteData.siteURL} target="_blank">this webform,</a> or by calling our automated, toll-free (within the United States) phone number: 1-833-874-2272. Please be aware that your public Caller ID information may be collected for business purposes if you choose the phone call method.</p><p>
          </p><p className="italic" style={{fontStyle: 'italic'}}>For inquiries about our Privacy Policy that are not related to CCPA, please use the <a href="#contact">contact</a> information at the end of this Privacy Policy.</p>
          <h2 id="8.3">8.3 Personal Information</h2>
          <p>The State of California Civil Code, Division 3, Part 4, Title 1.81.5. California Consumer Privacy Act of 2018 [1798.100 - 1798.199], CCPA, defines “personal information” as including “…information that identifies, relates to, describes, is capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer or household.”</p>
          <p>For the purposes of our Privacy Policy, the “person” is “you” (“your”, “user”). The personal information we collect may include:</p>
          <ul>
            <li><em>Display Name</em> - If you enter personal information into the service\'s "Display Name" text input field, it will be used for business purposes, including using it to temporarily identify you by your chosen display name in a service session.</li>
            <li><em>IP Address</em> – Your public “Internet Protocol” address sent to us by your web browser.</li>
            <li><em>GUID</em> – A unique “Generic User Identification” created when you visit our site, use our service, install our app, add our extension, or subscribe to Notifications which may be stored in a cookie.</li>
            <li><em>Anonymous Diagnostic Data</em> – Anonymous service diagnostic data, including but not limited to network connection conditions.</li>
            <li><em>UA</em> – The “User Agent” and version of your web browser; e.g. Chrome 84, Firefox 79, Safari 13, etc.</li>
            <li><em>OS</em> – The “Operating System” and version used by your hardware; e.g. Windows 10, macOS 10.15, etc.</li> </ul>
          <h2 id="8.4">8.4 Necessity To Maintain Your Personal Information</h2>
          <p>The personal information we collect may be used for the following business purposes, which are necessary for us in order to:</p>
          <ul>
            <li>Offer you our products.</li>
            <li>Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity.</li>
            <li>Debug to identify and repair errors that impair existing intended functionality.</li></ul>
            <h2 id="8.5">8.5 Opt-out / Opt-in For Sale Of Personal Information</h2>
    <p>We do not explicitly sell your personal information; therefore, there is no need to opt-out of the sale of your personal information. You may submit a CCPA request as described in Section 8.2 to preemptively opt-out or opt-in your personal information to a sale if one is made within 12-months from the date we receive your request.</p>

  <h3 id="eu-data">9. E.U. General Data Protection Regulation (“GDPR”)</h3>
    <p>This Section 9 applies to you if you are a national of a European Economic Area (“EEA”) member state. This section describes our good faith effort to meet our obligations if GDPR applies to you.</p>

  <h2 id="9.1">9.1 GDPR Owner</h2>
    <p>You can contact our GDPR owner via this <a href={siteData.privacyMailLink}>email link,</a> or post:</p>

    <p className="lh">Tightrope Interactive, Inc.<br />
    ATTN: GDPR Request<br />
    248 3rd St. #312<br />
    Oakland, California 94607-4375<br />
    United States of America</p>
    <p className="italic"><em>For inquiries about our Privacy Policy that are not related to GDPR, please use the contact information at the end of this Privacy Policy.</em></p>

  <h2 id="9.2">9.2 Personal Data</h2>
    <p>European Union regulation 2016/679, GDPR, defines “personal data” as “…any information relating to an identified or identifiable natural person (‘data subject’); an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person”</p>

    <p>For the purposes of our Privacy Policy, the “data subject” is “you” (“your”, “user”). The personal data we collect may include:</p>
  <ul>
    <li><em>Display Name</em> - If you enter personal data into the service's "Display Name" text input field, it will temporarily identify you by your chosen display name in a service session.</li>
    <li><em>IP Address</em> – Your public “Internet Protocol” address sent to us by your web browser.</li>
    <li><em>GUID</em> – A unique “Generic User Identification” created when you visit our site, use our service, install our app, add our extension, or subscribe to Notifications.</li>
    <li><em>Anonymous Diagnostic Data</em> – Anonymous service diagnostic data, including but not limited to network connection conditions.</li>
  </ul>

    <p>The personal data we collect may be used for the following purposes:</p>
  <ul>
    <li>Fraud detection to prevent abuse of our products.</li>
    <li>Geography detection to aid with fraud detection, and the delivery of our products appropriate for your location.</li></ul>

    <p>Our basis for processing personal data includes:</p>
  <ul>
    <li>GDPR Recital 47: “The processing of personal data strictly necessary for the purposes of preventing fraud also constitutes a legitimate interest of the data controller concerned.”</li>
    <li>GDPR Article 6(1)(f): “processing is necessary for the purposes of the legitimate interests pursued by the controller or by a third party…”</li>
  </ul>

  <h2 id="9.3">9.3 Disclosure</h2>
    <p>We may pass your personal data without first obtaining your consent to third parties listed in <a href="#section_six">Section 6</a>.</p>

  <h2 id="9.4">9.4 Data Retention</h2>
    <p>We may retain your public IP address in server logs for a time period of at least 20 days. GUID data may be retained for a period of at least 90 days after the last use of our products by a user with a GUID.</p>

  <h2 id="9.5">9.5 Contact GDPR Owner</h2>
  <p>Please contact our GDPR owner as described in Section 9.1 to exercise your rights as a GDPR data subject, or to file a complaint. The GDPR owner can help you with GDPR-specific matters including:</p>
  <ul>
    <li>Request a copy of information, if any, stored about you.</li>
    <li>Correct information, if any, stored about you.</li>
    <li>Erase information, if any, stored about you.</li>
    <li>Restrict how information, if any, about you is used.</li>
    <li>Transfer the information, if any, about you.</li>
    <li>Object to how your information, if any, is used in certain cases.</li>
    <li>Request why we are unable to fulfill your request, if applicable.</li>
  </ul>

  <h3 id="cws">10. Privacy Practices Disclosure For Chrome Web Store</h3>
    <p>Pursuant to Section 6 of the Google Chrome Web Store “Updated Privacy Policy & Secure Handling Requirements” “Updated on Thursday, November 19, 2020”, our extensions for Google Chrome collect your “Location” (e.g. region, IP address), and the “User Activity” (e.g. clicks) of our extensions. We use this information to understand the usage of and improve our products.</p>
    <p>Our extensions request the minimum browser permissions and site permissions required to function. You as the user can review the “Site access” and “Permissions” of extensions by opening chrome://extensions in Chrome.</p>
    <p>We do not sell this data to third parties, use or transfer this data for purposes that are unrelated to the item’s (extension’s) core functionality, or use or transfer this data to determine creditworthiness or for lending purposes knowingly by us.</p>

  <h3 id="policy-updates">11. Policy Updates</h3>
    <p>We reserve the right to modify this Privacy Policy at any time. We will update this Privacy Policy if we make material changes to it.</p>

    <h3 id="contact-us"><span id="contact">12. Contact Us</span></h3>
    <p>If you have questions or concerns about this Privacy Policy, its implementation, or feel that we have not followed it, please let us know by <a href="/contact-us/" target="_blank">email</a> or post:</p>

    <p className={Styles.lh}>Tightrope Interactive, Inc.<br /><br />
    ATTN: Privacy Policy – General Inquiry<br /><br />
    248 3rd St. #312<br /><br />
    Oakland, California 94607-4375 <br /><br />
    contactus@fabtab.org</p>

    <FooterlinksSingle></FooterlinksSingle>
        </div>
        <script
        dangerouslySetInnerHTML={{
          __html: `
       let domain = window.location.hostname ;
		const splitArr = domain.split(".");
		const arrLen = splitArr.length;
if (arrLen > 2) {
  domain = splitArr[arrLen - 2] + "." + splitArr[arrLen - 1];
  if (
    (splitArr[arrLen - 2].length === 2 &&
    splitArr[arrLen - 1].length === 2)
  ) {
    domain = splitArr[arrLen - 3] + "." + domain;
  }
}






		<!--//notifications
(function(){
        window.notificationCommands = window.notificationCommands || [];
        function adn(){
            window.notificationCommands.push(arguments);
        }
        adn("config",{
              serviceDomain:"https://notifications."+domain,
              workerUrl:"/service_worker.js",
             "askFrequency": 1   ,
              tags:{
                  extInstalled:false,
                  "partner":domain
              }
        })
        adn("tagsFromQuery",{"partner":"p","campaign":"c"},"user_type");
    })();


		  var scr = document.createElement( 'script' );
  scr.setAttribute( 'src', "https://notifications."+ domain +"/js/latest/client.js" );
scr.defer = true;
  document.body.appendChild( scr );



		var ntfn_src = document.createElement( 'script' );
   ntfn_src.setAttribute( 'src', "https://notifications."+ domain +"/js/latest/unsubscribe.js" );
   ntfn_src.defer = true;
  document.body.appendChild( ntfn_src );`}}
  />
      </section>
    )
  }
}
export default UpdatedPrivacy
